/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import Grid from "@material-ui/core/Grid"
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';

function Loading() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
      textAlign: "center",
      marginTop: "25%"
    },
    progress: {
      alignSelf: 'center',
      width: '100%'
    }
  }));
  const classes = useStyles();

  return (
    <Grid container direction="row" className={`container ${classes.root}`}>
      <LinearProgress variant='indeterminate' className={classes.progress} />
    </Grid>
  )
}
export default Loading;
